const libPictView = require('pict-view');

class LIMSTestbed extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('../LIMS-Application-Web').LIMSPict} */
		this.pict;
		/** @type {any} */
		this.options;
		this.latestForms = [];
		this.testbedProject = null;
		this.containerRNIs = [];
		this.noDataRefresh = false;
	}

	async onBeforeRenderAsync(pCallback, pRenderable)
	{
		// Close panels on page load.
		this.pict.views.HeadlightPanels.closeAllUnpinnedPanels();
		const session = await new Promise((resolve, reject) =>
		{
			this.pict.HeadlightRestClient.getJSON('CheckSession', (error, result) =>
			{
				resolve(result);
			});
		});
		if (!session.LoggedIn)
		{
			return;
		}
		if (!this.noDataRefresh)
		{
			this.pict.PictApplication.rnis = await this.pict.providers.DocumentProvider.getReportNamedInstancesByCustomer(this.AppData.CurrentUser?.CustomerID);
			this.testbedProject = await new Promise((resolve, reject) =>
			{
				this.pict.HeadlightRestClient.getJSON(`Projects/By/GUIDProject/testbed-project-${ session.CustomerID }`, (error, result) =>
				{
					resolve(result.length ? result[0] : null);
				});
			});
			if (!this.testbedProject)
			{
				this.pict.views.HeadlightPanels.toast({
					message: 'No testbed set up for this customer, redirecting...',
					type: 'is-warning',
				});
				this.pict.providers.LIMSRouter.router.navigate('/PSRS/Sample/List/FilteredTo/FSF~CreateDate~DESC~0');
				return;
			}
			this.containerRNIs = await this.pict.providers.DocumentProvider.getCreatableContainerRNIsByProject(this.testbedProject.IDProject);
			this.latestForms = await new Promise((resolve, reject) =>
			{
				this.pict.HeadlightRestClient.getJSON(`Documents/FilteredTo/FBV~IDProject~EQ~${ this.testbedProject.IDProject }~FBV~CreatingIDUser~EQ~${ session.UserID }~FSF~CreateDate~DESC~0`, (error, result) =>
				{
					resolve(result);
				});
			});
		}
		else
		{
			// TODO: This state tracking is doing odd stuff later
			this.noDataRefresh = false;
		}
		super.onBeforeRenderAsync(pCallback, pRenderable);
	}

	async createDocument()
	{
		await this.rerender(true);
		// TODO: Some of this stuff like the hiding things with ids is pretty jank, need a better mechanism for this.
		this.pict.views.HeadlightPaneDocuments.Intent =
		{
			type: 'add',
			handler: (IDDocument) =>
			{
				this.pict.views.HeadlightPanels.closeAllUnpinnedPanels();
				this.renderAsync();
			},
			afterRenderHandler: () =>
			{
				this.pict.views.DocumentCreate.CurrentDocumentRecord.Project = this.testbedProject.IDProject;
				const stuffToHide = [ 'HeadlightPanels-DocumentPanel-Search-Tab', 'DocumentCreate-Entry-Project-Wrapper', 'DocumentCreate-ClearButton' ];
				for (const s of stuffToHide)
				{
					document.getElementById(s)?.classList?.add?.('is-hidden');
				}
			},
		};
		this.pict.views.HeadlightPanels.handlePanelToggle('Documents', 'open');
		this.pict.views.HeadlightPanels.toggleTabContent('HeadlightPanels-DocumentPanel-Create', 'Document');
	}

	async createContainerForm()
	{
		this.fable.HeadlightModal.addLoader('Creating Document...');
		try
		{
			await this.rerender(true);
			// Just use the first container form we found for now.
			const tmpDocumentRecord =
			{
				DocumentType: this.containerRNIs[0].Hash,
				Name: this.containerRNIs[0].Name,
				IDProject: this.testbedProject.IDProject,
			};
			await this.pict.providers.DocumentProvider.createDocument(tmpDocumentRecord);
			await this.rerender();
		}
		catch (e)
		{
			this.log.error('Error creating document: ', e);
		}
		this.fable.HeadlightModal.dismissLoader();
	}

	/**
	 * Swaps out the template for the document name for an in line editable one.
	 * @param {number} id - The document's ID.
	 * @param {string} currentName - The document's current Name.
	 */
	async editDocumentName(id, currentName)
	{
		await this.rerender(true);
		const docElement = document.getElementById(`document-id-${ id }-container`);
		if (docElement)
		{
			docElement.innerHTML = /*html*/`
				<input id="document-id-${ id }-editable" value="${ currentName }" style="width: 70%;"/>
				<span class="button is-ghost icon is-size-6" onclick="_Pict.views.LIMSTestbed.rerender(true)">
					<i class="fas fa-circle-x"></i>
				</span>
				<span class="button is-ghost icon is-size-6" onclick="_Pict.views.LIMSTestbed.applyDocumentName(${ id })">
					<i class="fas fa-circle-check"></i>
				</span>
			`;
		}
	}

	/**
	 * Applies a name edit to the document.
	 * @param {number} id - The document's ID.
	 */
	async applyDocumentName(id)
	{
		/** @type {any} */
		const docElement = document.getElementById(`document-id-${ id }-editable`);
		if (docElement?.value)
		{
			this.fable.HeadlightModal.addLoader('Updating Document...');
			try
			{
				const tmpResult = await new Promise((resolve, reject) =>
				{
					this.pict.HeadlightRestClient.updateEntity('Document', { IDDocument: id, Name: docElement.value, IDProject: this.testbedProject.IDProject }, (pError, pResult) =>
					{
						if (pError)
						{
							reject(pError);
						}
						resolve(pResult);
					});
				});
				if (tmpResult)
				{
					this.log.info('Document changes saved successfully');
					this.pict.views.HeadlightPanels.toast({ message: 'Document updated successfully.', type: 'is-success' });
				}
			}
			catch (e)
			{
				this.log.error('Error updating document: ', e);
			}
		}
		else
		{
			this.pict.views.HeadlightPanels.toast({ message: 'No name was entered, Document name not updated.', type: 'is-warning' });
		}
		await this.rerender();
		this.fable.HeadlightModal.dismissLoader();
	}

	/**
	 * Rerenders the view.
	 * @return {Promise<void>}
	 */
	async rerender(noDataRefresh)
	{
		return await new Promise((resolve, reject) =>
		{
			if (noDataRefresh)
			{
				this.noDataRefresh = true;
			}
			this.renderAsync(()=>
			{
				return resolve();
			});
		});
	}
}

module.exports = LIMSTestbed;
module.exports.default_configuration = (
	{
		ViewIdentifier: 'LIMSTestbed',
		DefaultRenderable: 'LIMSTestbed',
		DefaultDestinationAddress: '#LIMS-Application-Container',

		AutoRender: true,

		CSS: '',

		Templates: [
			{
				Hash: 'LIMSTestbed-Wrapper',
				Template: /*html*/`
				<section id="LIMSTestbed" class="form p-5">
					<h2 class="title is-4 mb-3">LIMS Testbed</h2>
					<div class="content">
						<div class="columns is-vcentered">
							<div class="column">
								<button 
									type="button"
									id="LIMSTestbed-Create-Document" 
									class="button is-link" 
									onclick="_Pict.views.LIMSTestbed.createDocument()"
								>
									<span class="icon mr-3">
										<i class="fas fa-fw fa-file"></i>
									</span>
									Create New Form
								</button>
								<button 
									type="button"
									id="LIMSTestbed-Create-Container-Form" 
									class="button is-link {~TIfAbs:LIMSTestbed-Hide-Class:Record:Context[0].containerRNIs.length^==^0~}" 
									onclick="_Pict.views.LIMSTestbed.createContainerForm()"
								>
									<span class="icon mr-3">
										<i class="fas fa-fw fa-list-check"></i>
									</span>
									Create Generic Materials Form
								</button>
							</div>
						</div>
						<div class="columns is-vcentered">
							{~T:LIMSTestbed-Documents:Context[0].latestForms~}
						</div>
					</div>
				</section>`,
			},
			{
				Hash: 'LIMSTestbed-Hide-Class',
				Template: 'is-hidden',
			},
			{
				Hash: 'LIMSTestbed-Documents',
				Template: /*html*/`
					{~TIfAbs:LIMSTestbed-Documents-Items:Record:Record.length^>^0~}
					{~TIfAbs:LIMSTestbed-Documents-Empty:Record:Record.length^<=^0~}
				`,
			},
			{
				Hash: 'LIMSTestbed-Documents-Empty',
				Template: /*html*/`
				<div class="notification empty-message m-3 is-fullwidth column">
					<p class="has-text-centered">
						<span class="icon">
							<i class="fa fa-fw fa-info-circle"></i>
						</span>
						<span class="icon-text">No documents created by your user were found in the testbed project.</span>
					</p>
				</div>`,
			},
			{
				Hash: 'LIMSTestbed-Documents-Items',
				Template: /*html*/`
				<div id="LIMSTestbed-Documents-Items" class="column">
					<style>
						.document-entry-row
						{
							display:flex;
							justify-content: space-between;
						}
						ul 
						{
							list-style-type: none !important;
						}
						.document-entry
						{
							border-top: 1px solid var(--bulma-border);;
							border-bottom: 1px solid var(--bulma-border);;
						}
						.document-status
						{
							margin-right: 10vw;
						}
					</style>
					{~TS:LIMSTestbed-Documents-Item:Record~}
				</div>`,
			},
			{
				Hash: 'LIMSTestbed-Documents-Actions',
				Template: /*html*/`
					<!-- LIMS testbed document action cell (bespoke buttons; NOT the PSRS list action-cell template) -->
					<div class="document-actions">
						<ul class="buttons has-addons is-centered">
							<!-- TODO: check if the entity is print-able - currently, they both are -->
							<li>
								<a class="button is-ghost" href="javascript:void(0)" onclick="event.preventDefault(); _Pict.providers.DocumentProvider.viewDocumentFile('_blank', false, {~D:Record.IDDocument~});">
									<span class="icon">
										<i class="fas fa-print"></i>
									</span>
									<span class="icon-text">Print</span>
								</a>
							</li>
							<li>
								<a class="button is-ghost" href="#/Document/{~D:Record.GUIDDocument~}" title="{~TBR:Record.Name~}">
									<span class="icon">
										<i class="fas fa-search"></i>
									</span>
									<span class="icon-text">View</span>
								</a>
							</li>
							<li>
								<a class="button is-ghost" onclick="_Pict.providers.DocumentProvider.openFormByIDDocument(event, {~D:Record.IDDocument~});" title="{~TBR:Record.Name~}">
									<span class="icon">
										<i class="fas fa-pencil"></i>
									</span>
									<span class="icon-text">Edit</span>
								</a>
							</li>
						</ul>
					</div>`,
			},
			{
				Hash: 'LIMSTestbed-Documents-Item',
				Template: /*html*/`
				<div class="panel-block is-block-flex is-align-items-left is-relative p-4 document-entry">
					<div class="is-block-flex is-align-items-left m-2" style="flex-grow: 1">
						<div>
							<span class="tag">#{~D:Record.SequenceNumber~}</span>&nbsp;
							<span id="document-id-{~D:Record.IDDocument~}-container">
								{~D:Record.Name~}
								<span class="button is-ghost icon is-size-7 {~TIfAbs:LIMSTestbed-Hide-Class:Record:Record.CanEdit^==^false~} {~TIfAbs:LIMSTestbed-Hide-Class:Record:Record.Locked^==^1~}" onclick="_Pict.views.LIMSTestbed.editDocumentName({~D:Record.IDDocument~}, '{~D:Record.Name~}')">
									<i class="fas fa-pencil"></i>
								</span>
							</span>
						</div>
						<div class="document-entry-row is-size-7">
							<span>
								<b class="has-text-text-50">Type:</b> {~DocumentTypeName:Record.DocumentType~}
							</span>
							<span class='document-status'>
								<b class="has-text-text-50">Status:</b> {~D:Record.Status~}
							</span>
						</div>
						<div class="is-size-7">
							<span class="has-text-soft">Created on</span>
							<span>{~DateFormatNoFallback:Record.CreateDate^MMMM DD, YYYY - hh:mm a^~}</span>
							<span class="has-text-soft">by</span>
							<span>{~Entity:User^Record.CreatingIDUser^LIMSTestbed-Documents-Item-User^~}</span>
						</div>
					</div>
					<div class="image">
						{~T:LIMSTestbed-Documents-Actions:Record~}
					</div>
				</div>`,
			},
			{
				Hash: 'LIMSTestbed-Documents-Item-User',
				Template: /*html*/`{~D:Record.NameFirst~} {~D:Record.NameLast~}`,
			},
		],
		Renderables: [
			{
				RenderableHash: 'LIMSTestbed',
				TemplateHash: 'LIMSTestbed-Wrapper',
				RenderMethod: 'replace',
			} ],
	});
